export default __webpack_public_path__ + "static/media/lemonpowder.4f56666b.jpg";